import { LoginRequestDialogComponent } from '@Components/Dialog/login-request-dialog/login-request-dialog.component';
import { FooterComponent } from '@Components/footer/footer.component';
import { HeaderComponent } from '@Components/header/header.component';
import { AuthService } from '@Services/auth.service';
import { ContactsEffects } from '@State/Effects/contacts.effects';
import { MuseumEffects } from '@State/Effects/museum.effects';
import { UserEffects } from '@State/Effects/user.effects';
import { cartReducer } from '@State/Reducers/cart.reducer';
import { userContactsReducer } from '@State/Reducers/contacts.reducer';
import { museumsPaginatedReducer } from '@State/Reducers/paginatedMuseum.reducer';
import { selectedMuseumReducer } from '@State/Reducers/selectedMuseum.reducer';
import { slmDetailsReducer } from '@State/Reducers/slmDetails.reducer';
import { userReducer } from '@State/Reducers/user.reducer';
import { CustomTranslateLoader } from '@Utils/CustomTranslateLoader';
import {
  initKeyCloakConfig,
  oauthModuleConfigFactory,
  storageFactory,
} from '@Utils/keycloak';
import { DOCUMENT, registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { provideStoreDevtools, StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { OAuthModule, OAuthModuleConfig, OAuthStorage } from 'angular-oauth2-oidc';
import { TestComponent } from './Components/test/test.component';
import { LanguageService } from './Services/language.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_CONFIG } from '@Core/config/app-config';

const isProduction = typeof window !== 'undefined' && (window as any).__env?.PRODUCTION === 'true';

/* istanbul ignore next */
export function HttpLoaderFactory(http: HttpClient, document: Document) {
  return new CustomTranslateLoader(http, document);
}

export function initLanguage(languageService: LanguageService): () => Promise<void> {
  return () => languageService.initializeLanguage();
}

registerLocaleData(localeIt);

@NgModule({ declarations: [AppComponent, TestComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient, DOCUMENT],
            },
        }),
        OAuthModule.forRoot(),
        HeaderComponent,
        FooterComponent,
        FontAwesomeModule,
        StoreModule.forRoot({
            user: userReducer,
            selectedMuseum: selectedMuseumReducer,
            allMuseumsPaginated: museumsPaginatedReducer,
            cart: cartReducer,
            slimMuseumsDetails: slmDetailsReducer,
            userContacts: userContactsReducer
        }, {}),
        EffectsModule.forRoot([UserEffects, MuseumEffects, ContactsEffects]),
        LoginRequestDialogComponent
    ],
    providers: [
      {
        provide: LOCALE_ID,
        useValue: 'it-IT'
      },
      {
        provide: OAuthModuleConfig,
        useFactory: oauthModuleConfigFactory,
        deps: [APP_CONFIG]
      },
      provideStoreDevtools({
        maxAge: 25,
        logOnly: isProduction,
        autoPause: false,
        connectInZone: true
      }),
      provideAppInitializer(() => {
        const initializerFn = (initLanguage)(inject(LanguageService));
        return initializerFn();
      }),
      provideAppInitializer(() => {
        const initializerFn = (initKeyCloakConfig)(inject(AuthService));
        return initializerFn();
      }),
      {
          provide: OAuthStorage,
          useFactory: storageFactory,
      },
      LanguageService,
      AuthService,
      provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class AppModule {}
